// AboutSection.jsx
import React from 'react';
import './AboutSection.css';
import { Card, CardContent } from './ui/card';
import { Award, Users, Globe, Shield } from 'lucide-react';
import { mockCompanyData } from './mock';

const AboutSection = () => {
  const achievements = [
    { icon: Award, label: "Industry Awards", value: "15+" },
    { icon: Users, label: "Expert Team", value: "50+" },
    { icon: Globe, label: "Global Clients", value: "2500+" },
    { icon: Shield, label: "Uptime Guarantee", value: "99.9%" }
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-grid">
          {/* Left Content */}
          <div className="about-left">
            <div className="about-intro">
              <div className="about-badge">About Us</div>
              <h2 className="about-title">
                Leading the Future of
                <span className="about-highlight"> Technical Support</span>
              </h2>
              <p className="about-text">{mockCompanyData.name} has been at the forefront of technical support innovation for over a decade. We combine cutting-edge technology with human expertise to deliver unparalleled service experiences.</p>
              <p className="about-text">Our mission is to bridge the gap between complex technology and seamless user experiences, ensuring that businesses can focus on what they do best while we handle their technical needs.</p>
            </div>

            <div className="about-achievements">
              {achievements.map((item, index) => {
                const Icon = item.icon;
                return (
                  <Card key={index} className="about-achievement-card">
                    <CardContent className="about-achievement-content">
                      <div className="about-icon-wrapper">
                        <Icon className="about-icon" />
                      </div>
                      <div className="about-value">{item.value}</div>
                      <div className="about-label">{item.label}</div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>

          {/* Right Content */}
          <div className="about-right">
            <Card className="about-values-card">
              <CardContent className="about-values-content">
                <h3 className="values-title">Our Values</h3>
                <div className="values-list">
                  {[
                    { title: 'Customer First', desc: "Every decision we make is guided by what's best for our clients." },
                    { title: 'Innovation', desc: 'We constantly evolve our services to stay ahead of technological trends.' },
                    { title: 'Excellence', desc: 'We maintain the highest standards in everything we deliver.' },
                    { title: 'Transparency', desc: 'Clear communication and honest practices in all our interactions.' }
                  ].map((value, index) => (
                    <div className="value-item" key={index}>
                      <div className="value-dot" />
                      <div>
                        <h4 className="value-title">{value.title}</h4>
                        <p className="value-desc">{value.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
